var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "discover_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".discover_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#231f20}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__SVGID_1_",
    x1: 19.764,
    x2: 22.076,
    y1: 22.472,
    y2: 17.528,
    gradientTransform: "matrix(1 0 0 -1 0 40)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#e45e26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f8a020"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.92,
    cy: 20,
    rx: 2.72,
    ry: 2.73,
    style: {
      fill: "url(#discover_svg__SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.54c0-.08 0-.12.11-.11h1.47a2.793 2.793 0 0 1 1.9.75c.363.336.606.782.69 1.27A2.53 2.53 0 0 1 7.32 22a2.413 2.413 0 0 1-1.45.6c-.6.05-1.2 0-1.8 0-.08 0-.07 0-.07-.08v-4.98zm1 4.06c0 .07 0 .1.09.09s.4 0 .6 0c.372-.01.728-.155 1-.41.44-.41.627-1.024.49-1.61a1.53 1.53 0 0 0-1.1-1.25 3.234 3.234 0 0 0-.93-.09c-.09 0-.12 0-.12.11C5 19 5 21.07 5 21.6zM34.39 20.41 36 22.57h-1.12a.202.202 0 0 1-.19-.1c-.42-.63-.84-1.26-1.27-1.88a.1.1 0 0 0-.13 0c-.05 0 0 .06 0 .09v1.85c0 .1 0 .12-.12.12h-.8c-.07 0-.09 0-.09-.09v-5c0-.05 0-.08.07-.08h1.72a1.76 1.76 0 0 1 1.07.41c.337.306.502.759.44 1.21a1.33 1.33 0 0 1-1.08 1.32l-.11-.01zM33.25 19v.68c0 .08 0 .1.09.1h.45a.73.73 0 0 0 .72-.74.69.69 0 0 0-.49-.73 2.595 2.595 0 0 0-.68-.07c-.07 0-.09 0-.09.1V19zM28.74 17.53c0-.08 0-.1.1-.1h2.65c.07 0 .1 0 .1.09v.71c0 .07 0 .08-.09.08h-1.64c-.1 0-.12 0-.11.11v.93c0 .08 0 .1.09.09h1.58c.09 0 .1 0 .1.1v.69c0 .07 0 .08-.09.08h-1.57c-.1 0-.12 0-.11.12v1.16c0 .08 0 .11.09.1h1.65c.08 0 .1 0 .1.1v.71c0 .05 0 .07-.08.07h-2.69c-.08 0-.08 0-.08-.09v-4.95zM10.71 21.08c.117.257.323.463.58.58.272.13.588.13.86 0a.65.65 0 0 0 .42-.62.61.61 0 0 0-.39-.6c-.28-.14-.59-.23-.88-.35a1.8 1.8 0 0 1-.75-.52 1.002 1.002 0 0 1-.21-.52 1.43 1.43 0 0 1 1.06-1.65 2.11 2.11 0 0 1 2 .44s.06.06 0 .11-.3.38-.44.57-.07.05-.11 0a.998.998 0 0 0-.58-.34.83.83 0 0 0-.8.25.44.44 0 0 0 .09.67c.219.135.454.242.7.32.227.084.448.184.66.3.411.216.675.636.69 1.1a1.63 1.63 0 0 1-1.22 1.77 2 2 0 0 1-2.3-.86v-.09l.62-.56zM23.36 17.43h1c.07 0 .09 0 .12.08.3.77 1.19 3 1.32 3.34.07-.07 1-2.31 1.36-3.35 0 0 0-.07.09-.07h1l-2.19 5.19a.1.1 0 0 1-.11.08h-.39a.1.1 0 0 1-.11-.07l-2.1-5.08s.02-.07.01-.12zM17.89 18.82a2.422 2.422 0 0 0-.59-.44 1.64 1.64 0 0 0-2.21.94 1.8 1.8 0 0 0 .34 1.93c.333.354.806.541 1.29.51a1.537 1.537 0 0 0 1-.42l.13-.12v1.07c0 .06 0 .09-.06.11a2.79 2.79 0 0 1-3.15-.52 2.642 2.642 0 0 1-.76-1.84 2.71 2.71 0 0 1 3.91-2.45s.06 0 .06.08l.04 1.15zM9.69 22.46c0 .08 0 .11-.11.11h-.81c-.07 0-.09 0-.09-.08v-5c0-.08 0-.09.09-.09h.81c.09 0 .11 0 .11.11v4.95z",
    className: "discover_svg__st2"
  })));
};
export default SvgDiscover;